export const InternalAndExternal = {
  INTERNAL: 'Internal',
  EXTERNAL: 'External'
};
